import React, { CSSProperties } from "react";

type Orientation = "horizontal" | "vertical";
type TextPosition = "center" | "left" | "right" | "top" | "bottom";

interface DividerProps {
  orientation?: Orientation;
  text?: string;
  textPosition?: TextPosition;
  className?: string;          // container classes
  style?: CSSProperties;       // container inline styles
  textClassName?: string;      // classes specifically for text span
  textStyle?: CSSProperties;   // inline styles specifically for text span
}

const Divider: React.FC<DividerProps> = ({
  orientation = "horizontal",
  text = "",
  textPosition = "center",
  className = "",
  style = {},
  textClassName = "",
  textStyle = {},
}) => {
  const isHorizontal = orientation === "horizontal";

  // Determine flex direction based on orientation and text position
  const flexDirection = isHorizontal
    ? textPosition === "top"
      ? "flex-col"
      : textPosition === "bottom"
      ? "flex-col-reverse"
      : "flex-row"
    : textPosition === "left"
    ? "flex-row"
    : textPosition === "right"
    ? "flex-row-reverse"
    : "flex-col";

  // Tailwind justify-content equivalent based on text position
  const justifyContent = (() => {
    switch (textPosition) {
      case "left":
      case "top":
        return "justify-start";
      case "center":
        return "justify-center";
      case "right":
      case "bottom":
        return "justify-end";
      default:
        return "justify-center";
    }
  })();

  // Divider line styles
  const dividerClasses = isHorizontal
    ? "border-t border-gray-300 flex-grow mx-2"
    : "border-l border-gray-300 flex-grow my-2";

  const textClasses = `whitespace-nowrap ${textClassName}`.trim();

  return (
    <div
      className={`flex ${flexDirection} items-center ${justifyContent} ${className}`}
      style={style}
    >
      {(textPosition === "left" || textPosition === "top") && text && (
        <span className={textClasses} style={textStyle}>
          {text}
        </span>
      )}

      <div className={dividerClasses}></div>

      {textPosition === "center" && text && (
        <span className={`${textClasses} mx-2`} style={textStyle}>
          {text}
        </span>
      )}

      {(textPosition === "right" || textPosition === "bottom") && text && (
        <span className={textClasses} style={textStyle}>
          {text}
        </span>
      )}
    </div>
  );
};

export default Divider;

